import { useApolloClient } from "@vue/apollo-composable";
import { handleError } from "@/services/AlertService";
import AddTrip from "../queries/AddTrip.graphql";

export function addTrip(coachType: string, features: string[], seatFacingDirection: string, seatPosition: string, reservationRequested: boolean, bookingId: string | null, fareKeys: string[], outboundJourneyKey: string, inboundJourneyKey: string, searchId: string) {
    const { client } = useApolloClient();
    return new Promise(async (resolve, reject) => {
        try {
            const result = await client.query({
                query: AddTrip,
                variables: {
                    coachType,
                    features,
                    seatFacingDirection,
                    seatPosition,
                    reservationRequested,
                    bookingId: bookingId || undefined,
                    fareKeys,
                    inboundJourneyKey,
                    outboundJourneyKey,
                    searchId,
                },
            });

            if (result.data.addTrip) {
                resolve(result.data.addTrip);
                return;
            }

            resolve(null);
            return;
        } catch (error) {
            console.error(error);
            handleError(error);
            reject(error);
        }
    });
}
